import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.scss";
import { FaBars, FaCog } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import DropdownOpenerIcon from "../../assets/images/Sidebar/dropdown-open-arrow.svg";
import DropdownCloserIcon from "../../assets/images/Sidebar/dropdown-close-arrow.svg";
import useMenuPermissions from '../../../config/side-bar'; // Adjust the path based on the location of the JSON file

interface MenuSection {
  title: string;
  links: { name: string; to: string }[];
}

interface SidebarProps {
  handleClick: (msg: boolean) => void;
}

function Sidebar({ handleClick }: SidebarProps) {
  const location = useLocation();
  const [sideNav, setSideNav] = useState(true);
  const [msg, setMsg] = useState(true);
  const [openSettings, setOpenSettings] = useState(false);
  const menuSections = useMenuPermissions();

  // Set all menus to be open by default
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    const initialMenus = menuSections.reduce((acc, section) => {
      console.log("acc", acc);
      acc[section.title] = true; // Initialize all menus as open
      return acc;
    }, {} as { [key: string]: boolean });
  
    setOpenMenus(initialMenus);
  }, [menuSections]); // The empty dependency array ensures this runs only once on mount

  const toggleMenu = (menuTitle: string) => {
    setOpenMenus(prevState => ({
      ...prevState,
      [menuTitle]: !prevState[menuTitle]
    }));
  };

  return (
    <>
      {sideNav ? (
        <div className="sidebar">
          <a className="sidenav_head d-flex justify-content-between align-items-center" href="#home">
            <span className="sidenav_head_title">Nautai Marine</span>
            <RxCross2
              className="sidebar_cross"
              onClick={() => {
                setSideNav(false);
                handleClick(msg);
              }}
            />
          </a>

          {menuSections.map((section, idx) => (
            <div key={idx}>
              <div
                onClick={() => toggleMenu(section.title)}
                className={`sidenav-sub-heading ${openMenus[section.title] ? "" : "sidenav-item-spacing"}`}
              >
                <img
                  src={openMenus[section.title] ? DropdownCloserIcon : DropdownOpenerIcon}
                  alt=""
                />
                <span>{section.title}</span>
              </div>

              {openMenus[section.title] && (
                <div className="sidebar-dropdown-items">
                  {section.links.map((link, index) => (
                    <Link
                      key={index}
                      to={link.to}
                      className={location.pathname.includes(link.to) ? "active" : ""}
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div className="sidebar-settings">
            <FaCog className="settings-icon" onClick={() => setOpenSettings(!openSettings)} />
            {openSettings && (
              <div className="settings-menu">
                <Link to="/admin/field-settings" onClick={() => setOpenSettings(!openSettings)}>Collection Settings</Link>
                <Link to="/admin/side-menu" onClick={() => setOpenSettings(!openSettings)}>Side Menu Editor</Link>
                <Link to="/app_clients" onClick={() => setOpenSettings(!openSettings)}>App Clients</Link>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="sidebar sidebar_collapsed">
          <a className="sidenav_collapsed_head" href="#home">
            <FaBars
              className="fabars-color"
              onClick={() => {
                setSideNav(true);
                handleClick(!msg);
              }}
            />
          </a>
        </div>
      )}
    </>
  );
}

export default Sidebar;
